/* nt-slider.js — auto-scrolling, drag-to-scrub photo strip.
   Works on any number of `.nt-strip` wrappers containing a `.nt-strip-track`.
   Each photo is rendered once; the strip scrolls back and forth between its two
   ends instead of looping. Multi-instance safe: each strip gets its own state + rAF loop. */
window.NT = window.NT || {};

(function (NT) {
  function initStrip(wrap) {
    var track = wrap.querySelector('.nt-strip-track');
    if (!track) return;

    var state = {
      pos: 0,
      dir: track.classList.contains('is-reverse') ? -1 : 1,
      speed: NT.reducedMotion() ? 0 : 0.45,
      dragging: false,
      dragStartX: 0,
      dragStartPos: 0,
      hover: false,
      resumeAt: 0,
      raf: null
    };

    function maxPos() {
      return Math.max(0, track.scrollWidth - wrap.clientWidth);
    }

    function down(e) {
      state.dragging = true;
      state.dragStartX = e.clientX;
      state.dragStartPos = state.pos;
      wrap.style.cursor = 'grabbing';
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
    }
    function move(e) {
      if (!state.dragging) return;
      var pos = state.dragStartPos - (e.clientX - state.dragStartX);
      state.pos = Math.min(Math.max(pos, 0), maxPos());
      track.style.transform = 'translateX(' + (-pos) + 'px)';
    }
    function up() {
      if (!state.dragging) return;
      state.dragging = false;
      wrap.style.cursor = 'grab';
      state.resumeAt = performance.now() + 900;
    }
    function enter() { state.hover = true; }
    function leave() { state.hover = false; up(); }

    wrap.addEventListener('pointerdown', down);
    wrap.addEventListener('pointermove', move);
    wrap.addEventListener('pointerup', up);
    wrap.addEventListener('pointercancel', up);
    wrap.addEventListener('mouseenter', enter);
    wrap.addEventListener('mouseleave', leave);

    function tick(t) {
      if (!state.dragging && !state.hover && !(state.resumeAt && t < state.resumeAt) && state.speed) {
        var max = maxPos();
        state.pos += state.speed * state.dir;
        if (state.pos >= max) { state.pos = max; state.dir = -1; }
        else if (state.pos <= 0) { state.pos = 0; state.dir = 1; }
        track.style.transform = 'translateX(' + (-state.pos) + 'px)';
      }
      state.raf = requestAnimationFrame(tick);
    }
    state.raf = requestAnimationFrame(tick);

    return function teardown() {
      cancelAnimationFrame(state.raf);
      wrap.removeEventListener('pointerdown', down);
      wrap.removeEventListener('pointermove', move);
      wrap.removeEventListener('pointerup', up);
      wrap.removeEventListener('pointercancel', up);
      wrap.removeEventListener('mouseenter', enter);
      wrap.removeEventListener('mouseleave', leave);
    };
  }

  function initAll(root) {
    NT.qsa('.nt-strip', root).forEach(function (wrap) {
      if (wrap.dataset.ntStripInit) return;
      wrap.dataset.ntStripInit = '1';
      initStrip(wrap);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})(window.NT);
